import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ScreenTrackingService} from '@angular/fire/analytics';
import {connectFunctionsEmulator, Functions} from '@angular/fire/functions';
import {RouterOutlet} from '@angular/router';
import {environment} from '../environments/environment';
import {ToastContainerComponent} from "./common/toast";
import {MetadataService} from './common/metadata.service';

@Component({
    selector: 'nexus-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastContainerComponent]
})
export class AppComponent {
  private readonly functions = inject(Functions);

  constructor(
    readonly metadataService: MetadataService,
    readonly screenTrackingService: ScreenTrackingService,
  ) {
    if(environment.useEmulatedFunctions) {
      connectFunctionsEmulator(this.functions, "127.0.0.1", 5001);
    }
  }
}
